export function generateElementId(prefix = '') {
   const randomPart = Math.random().toString(36).substring(2, 8);
   if (prefix === '') return randomPart;
   return `${prefix}-${randomPart}`;
}
